/*
 * Copyright (c) 2022 - present, Orangecells Innovation Lab Private Limited [https://orangecells.com]
 *
 * All rights reserved.
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "swiper/css/bundle";
import "./Styles.css";
import Layout from "./Layout/Layout";
import LandingPage from "./Pages/LandingPage";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Layout>
      <Routes>
        <Route path="/" element={<LandingPage />} />
      </Routes>
    </Layout>
  </BrowserRouter>
);
